import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { TopRequestorDto } from '../types';

interface TopRequestorsTableProps {
  data: TopRequestorDto[];
}

export function TopRequestorsTable({ data }: TopRequestorsTableProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Top Requestors</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/50">
              <tr>
                <th className="px-4 py-2 text-left font-medium">Requestor</th>
                <th className="px-4 py-2 text-center font-medium">Requests</th>
                <th className="px-4 py-2 text-center font-medium">Items</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={3} className="px-4 py-8 text-center text-muted-foreground">
                    No data available
                  </td>
                </tr>
              ) : (
                data.map((requestor, index) => (
                  <tr key={requestor.requestorIdNumber} className="border-b hover:bg-muted/50">
                    <td className="px-4 py-2">
                      <div className="flex items-center gap-2">
                        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-xs font-medium text-primary">
                          {index + 1}
                        </span>
                        <span>{requestor.requestorFullName}</span>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-center font-medium">{requestor.totalRequests}</td>
                    <td className="px-4 py-2 text-center">{requestor.totalItems}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
